import React from "react";
import "../../styles/footer.css";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  const year = new Date().getFullYear();

  const facebookUrl =
    "https://www.facebook.com/share/PdwhaCer7CNRXwUt/?mibextid=LQQJ4d";

  const linksData1 = [
    {
      path: "#services",
      title: "MARKETING",
    },
    {
      path: "#services",
      title: "ANALYTICS",
    },
    {
      path: "#services",
      title: "COMMERCE",
    },
  ];

  const linksData2 = [
    {
      path: "#about",
      title: "ABOUT",
    },
    {
      path: "#home",
      title: "SUPPORT",
    },
    {
      path: "#",
      title: "CONTACT",
    },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-wrapper">
          <div className="footer-logo">
            <h2>Beno</h2>
            <p className="description">Grow with us</p>

            <p className="footer-desc description">{t("FOOTER_DESC")}</p>
          </div>

          <div className="footer-content">
            <div className="footer-links">
              <div className="footer-links-title">{t("SOLUTIONS")}</div>
              <ul className="footer-links-container">
                {linksData1.map((item, index) => (
                  <li className="footer-links-item" key={index}>
                    <a href={item.path}>{t(item.title)}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links">
              <div className="footer-links-title">{t("COMPANY")}</div>
              <ul className="footer-links-container">
                {linksData2.map((item, index) => (
                  <li className="footer-links-item" key={index}>
                    <a href={item.path}>{t(item.title)}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div>
          <div className="social-links">
            <a className="social-btn" href={facebookUrl} target="blank">
              <i className="ri-facebook-fill"></i>
            </a>
            <a className="social-btn">
              <i className="ri-mail-line"></i>
            </a>
            <a className="social-btn" href="tel:+972526364654">
              <i className="ri-phone-fill"></i>
            </a>
          </div>
          <p className="copyright">{t("COPYRIGHTS", { year })}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
